import React, { useState, useContext, useEffect } from 'react';
import { 
  Col, FormControl, Modal, Pagination,
 } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardSubhead,
} from '@/shared/components/Card';
import { Button } from '@/shared/components/Button';
import {
  DropdownMenu, Dropdown, DropdownItem, DropdownToggle,
} from '@/shared/components/Dropdown';
import { FaArrowDownShortWide, FaArrowUpWideShort } from 'react-icons/fa6';
import { PiCaretUpDownFill } from 'react-icons/pi';
import toast from 'react-hot-toast';
import { Table } from '@/shared/components/TableElements';
import AddUser from './AddUsers';
import EditUser from './EditUser';
import { AuthContext } from '../../../../../context/AuthContext';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';
import DeleteModal from './DeleteModal';

const ResponsiveTable = () => {
  const { apiGlobal } = useContext(GlobalVarContext);
  const { restaurantid, userid } = useContext(AuthContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const [userData, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [holdIDforDelete, setHoldIDforDelete] = useState('');
  const [userDataForEdit, setUserDataForEdit] = useState({});
  const [loading, setLoading] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const fetchUserData = async () => {
    const formData = new FormData();
    formData.append('restaurant_id', restaurantid);
    try {
      const response = await fetch(`${apiGlobal}/restaurant/user_restaurant_data.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data?.status && data?.message === 'Success') {
        // console.log(data?.data);
        setUserData(data?.data);
        setFilteredData(data?.data);
      } else {
        setUserData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [restaurantid, sideBarRefresh?.restaurantUserRefresh]);

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    setFilteredData(
      userData.filter(user => user.name.toLowerCase().includes(query) 
      || user.username.toLowerCase().includes(query)),
    );
  }, [searchQuery, userData]);

  const handleStatusToggle = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === '1' ? '0' : '1';
      const formData = new FormData();
      formData.append('id', userId);
      formData.append('restaurant_id', restaurantid);
      formData.append('status', newStatus);
      const response = await fetch(`${apiGlobal}/restaurant/user_restaurant_status.php`, {
          method: 'POST',
          body: formData,
        });
      const data = await response.json();
      if (data.status) {
        toast.success(data.message);
        fetchUserData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error toggling status:', error);
    }
  };

  const handleAddUser = async (user) => {
    const location = [];

    user.locationsid.forEach((locationItem) => {
      location.push(locationItem.value);
    });

    try {
      setLoading(true);
      const formData = new FormData();
      Object.entries(user).forEach(([key, value]) => formData.append(key, value));
      formData.append('country_code', user.countryCode?.value);
      formData.append('restaurant_id', restaurantid);
      formData.append('location_ids', location.join(',')); 

      const response = await fetch(`${apiGlobal}/restaurant/user_restaurant_add.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data?.status && data?.message === 'Success') {
        toast.success('User added successfully');
        setShowModal(false);
        fetchUserData();
        setLoading(false);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error('Error adding user:', error);
    } finally {
      setLoading(false);
      }
  };

  const handleEditUser = (
    id, 
    name, 
username, 
// eslint-disable-next-line
country_code,
// eslint-disable-next-line
country_code_id, 
designation, 
password, 
mobile1, 
mobile2, 
locationids,
) => {
    setShowModalEdit(true);
    setUserDataForEdit({
      // eslint-disable-next-line
      id, name, username, country_code, country_code_id, designation, password, mobile1, mobile2, locationids,
    });
  };

  const [sortColumn, setSortColumn] = useState('name'); // This will track the column being sorted
  const [sortOrder, setSortOrder] = useState('asc');

const handleSort = (column) => {
  const newSortOrder = sortColumn === column 
  && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column

  const sortedData = [...filteredData].sort((a, b) => {
    if (column === 'name') {
      return newSortOrder === 'asc'
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name);
    }
    if (column === 'username') {
      return newSortOrder === 'asc'
        ? a.username.localeCompare(b.username)
        : b.username.localeCompare(a.username);
    }
    if (column === 'status') {
      return newSortOrder === 'asc' ? a.status - b.status : b.status - a.status;
    }
    return 0;
  });

  setSortColumn(column);
  setSortOrder(newSortOrder);
  setFilteredData(sortedData);
};

  const editUserHandler = async (values) => {
    // console.log(JSON.stringify(values, null, 2));
    
    // if (!values.locationids || values.locationsids.length === 0) {
    //   toast.error('Please select a location');
    //   return;
    // } 

    // console.log(values.locationsids);
    

      const location = [];
       values.locationsids.forEach((locationItem) => {
        location.push(locationItem.value);
      });

      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => formData.append(key, value));
      formData.append('country_code', values.country_code_id);
      formData.append('location_ids', location.join(','));
    try {
      setLoading(true);
        const url = await fetch(`${apiGlobal}/restaurant/user_restaurant_edit.php`, {
        method: 'POST',
        body: formData,
      });
      // console.log(url);
      const data = await url.json();
      // console.log(data);
      if (data?.status && data?.message === 'Record updated successfully.') {
        toast.success('User updated successfully.');
        setShowModalEdit(false);
        setLoading(false);
        fetchUserData();
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error('Error updating user:', error);
    } finally {
      setLoading(false);
      }
  };


  const handleDeleteModal = (id) => {
    setdeleteModalShow(true);
    setHoldIDforDelete(id);
  };

  const handleDeleteUser = async () => {
    const formData = new FormData();
    formData.append('id', holdIDforDelete);
    try {
      const url = await fetch(`${apiGlobal}/restaurant/user_restaurant_delete.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data?.status && data?.message === 'Data deleted successfully') {
        toast.success('User deleted successfully');
        setdeleteModalShow(false);
        setHoldIDforDelete('');
        fetchUserData();
    } else {
      toast.error(data?.message);
    }
  } catch (error) {
    console.error('Error deleting user:', error);
  }
};

  const renderTableRows = () => (
    filteredData.map((user, index) => (
      <tr key={user?.id}>
        <td>{index + 1}</td>
        <td>{user?.name}</td>
        <td>{user?.username}</td>
        <td>
          {user.status === '1' ? (
            <span className="bg-success text-white p-1 rounded">
              <i className="lnr lnr-checkmark-circle" /> Approved
            </span>
          ) : (
            <span className="bg-danger text-white p-1 rounded">
              <i className="lnr lnr-cross-circle" /> Not Approved
            </span>
          )}
        </td>
        <td>
          {user.type === '1' && (
            <Dropdown dir="ltr">
              <DropdownToggle
                variant="outline-primary"
                size="sm"
                style={{
                  fontSize: '12px', // Set text size
                  padding: '10px 20px', // Adjust padding to make it small
                  borderRadius: '40px', // Make it fully rounded
                }}
              >
                Actions
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleStatusToggle(user.id, user.status)}>
                  {user.status === '1' ? 'Mark as Not Approved' : 'Mark as Approved'}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}
        </td>
        <td>
          <Button
            variant="success"
            title="Edit"
            size="sm"
            onClick={() => handleEditUser(
              user?.id,
              user?.name,
              user?.username,
              user?.country_code,
              user?.country_code_id,
              user?.designation,
              user?.password,
              user?.mobile1,
              user?.mobile2,
              user?.location_ids,
              )}
          >
            <span className="lnr lnr-pencil" />
          </Button>
          {user?.type === '1' && (
            <Button 
              variant="danger" 
              title="Delete"
              size="sm"
              onClick={() => handleDeleteModal(user.id)}
            >
              <span className="lnr lnr-trash" />
            </Button>
          )}
        </td>
      </tr>
    ))
  );

  if (isLoading) return <div>Loading...</div>;
// Handle page change
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

// Pagination Logic - Slice data for the current page
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = userData.slice(indexOfFirstItem, indexOfLastItem);

// Total pages
const totalPages = Math.ceil(userData.length / itemsPerPage);


  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardSubhead>
              All Users <span className="red-text">Bitevize-Restaurant</span>
              <Button
                style={{ float: 'right' }}
                variant="primary"
                size="sm"
                onClick={() => setShowModal(true)}
              >
                Add User
              </Button>
            </CardSubhead>
            <FormControl
              type="text"
              placeholder="Search by name or username"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={{ width: '30%', marginTop: '10px' }}
            />
          </CardTitleWrap>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Sr no.</th>
                <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                  <PiCaretUpDownFill /> Name {sortColumn === 'name' 
                  && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
                </th>
                <th onClick={() => handleSort('username')} style={{ cursor: 'pointer' }}>
                  <PiCaretUpDownFill /> Username {sortColumn === 'username' 
                  && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
                </th>               
                <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
                  <PiCaretUpDownFill /> Status {sortColumn === 'status' 
                  && (sortOrder === 'asc' ? <FaArrowUpWideShort /> : <FaArrowDownShortWide />)}
                </th> 
                <th>Action</th>
                <th>Edit/Delete</th>
              </tr>
            </thead>
            <tbody>{renderTableRows()}</tbody>
          </Table>
        </CardBody>

        {/* Add User Modal */}
        <Modal 
          show={showModal} 
          onHide={() => setShowModal(false)} 
          centered
          size="xl"
          backdrop="static" // This prevents closing on clicking outside
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddUser onSubmit={handleAddUser} restaurantid={restaurantid} loading={loading} />
          </Modal.Body>
        </Modal>
          
        {/* Edit User Modal */}
        <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Edit User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditUser userDetails={userDataForEdit} onSubmit={editUserHandler} loading={loading} />
          </Modal.Body>
        </Modal>

        {/* Delete User Modal */}
        <DeleteModal
          show={deleteModalShow}
          handleClose={() => setdeleteModalShow(false)}
          handleDelete={handleDeleteUser}
          message="Are you sure you want to delete this User?"
        />
        {/* Pagination Controls */}
        <div style={{
          position: 'fixed', // Use 'fixed' to keep it in place relative to the viewport
          bottom: '20px', // Distance from the bottom of the viewport
          right: '20px', // Distance from the right of the viewport
          zIndex: 999, // Ensure it appears above other elements
          display: 'flex', // Flexbox for alignment
          justifyContent: 'flex-end', // Align content to the right within the div
          alignItems: 'center',  
    }}
        >
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index + 1}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        </div>
      </Card>
    </Col>
  );
};

export default ResponsiveTable;
